import { FC } from 'react';
import { FilterBlock } from '@cbridge-tools/filters-panel';
import { useTranslation } from 'react-i18next';
import { useSymbolMappingFilterItems } from '../_hooks/useSymbolMappingFilterItems';
import { ClearSymbolMappingFilterButton } from './ClearSymbolMappingFilter/ClearSymbolMappingFilterButton';
import { SymbolMappingFilterItem } from './SymbolMappingFilterItem/SymbolMappingFilterItem';
import { ISymbolMappingFilterProps } from './SymbolMappingFilter.interface';

export const SymbolMappingFilter: FC<ISymbolMappingFilterProps> = ({ isTradingAware = false, ...props }) => {
  const { t } = useTranslation();

  const items = useSymbolMappingFilterItems(isTradingAware);

  return (
    <FilterBlock
      label={t('text:configPage.symbolPools.section.otherFilters')}
      clearFilterAction={<ClearSymbolMappingFilterButton />}
      items={items}
      FilterBlockItemComponent={SymbolMappingFilterItem}
      {...props}
    />
  );
};
